import React from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';
import { TrendingUp, TrendingDown } from 'lucide-react';
import breakpoints from 'theme/breakpoints';

export default function MiniStatCard({ label, value, trend, isPositive = true, icon: IconComponent }) {
    return (
        <Card>
            <CardTop>
                {IconComponent && (
                    <IconWrap>
                        <IconComponent size={20} color={colors.secondaryPurple} />
                    </IconWrap>
                )}
                <Label>{label}</Label>
            </CardTop>
            <Value>{value}</Value>
            {trend && (
                <TrendRow>
                    {isPositive
                        ? <TrendingUp size={14} color={colors.success} />
                        : <TrendingDown size={14} color={colors.danger} />
                    }
                    <TrendText isPositive={isPositive}>{trend}</TrendText>
                </TrendRow>
            )}
        </Card>
    );
}

const Card = styled.div`
    background: ${colors.neutralLight};
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 1px 8px ${colors.night}08;
    border: 1px solid ${colors.night}11;
    flex: 1;
    min-width: 180px;

    @media screen and (max-width: ${breakpoints.sm}) {
        min-width: 100%;
    }
`;

const CardTop = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
`;

const IconWrap = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: ${colors.occasionalPurple}10;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Label = styled.span`
    font-size: 13px;
    color: ${colors.night};
    font-weight: 500;
`;

const Value = styled.div`
    font-size: 24px;
    font-weight: 700;
    color: ${colors.nightDark};
    margin-bottom: 6px;
`;

const TrendRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const TrendText = styled.span`
    font-size: 12px;
    color: ${({ isPositive }) => isPositive ? colors.success : colors.danger};
    font-weight: 500;
`;
